import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { JobPosting, JobPostingCreate, JobPostingFilter } from '../data/jobPosting';

export function createJobPostingService(client: AxiosInstance) {
  return createCrudService<JobPosting, JobPostingCreate, JobPostingFilter>(
    client,
    '/hrm/JobPosting',
    'id',
  );
}

export type JobPostingService = CrudService<JobPosting, JobPostingCreate, JobPostingFilter>;
